<template>
  <div id="dplayer"></div>
</template>

<script>
import DPlayer from 'dplayer'

export default {
  name: 'DPlayer',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    const dp = new DPlayer({
      container: document.getElementById('dplayer'),
      video: {
        url: this.url
      }
    })
  }
}
</script>

<style scoped>

</style>
